<template>
  <div id="client_input">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div class="input_list_pre">
            <ul>
              <li class="input_text">
                <div>
                  <span>会社名</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model.trim="form.corpName" maxlength="32"  placeholder="会社名"/>
                <div v-if="errors.corpName" class="error_text">{{errors.corpName}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>郵便番号</span>
                  <span class="small_p">（半角数値、ハイフン不要）</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model.trim="form.postcd" @keypress="validateNumber" @input="form.postcd=inputRestNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="0001111"/>
                <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
              </li>
              <li class="input_text2">
                <div>
                  <span>住所</span>
                  <span class="important small_text">必須</span>
                </div>
                <div class="input_field">
                  <input type="text" v-model.trim="form.state" placeholder="都道府県">
                  <span class="space"></span>
                  <input type="text" v-model.trim="form.city" placeholder="市区町村">
                </div>
                <div v-if="errors.state" class="error_text">{{errors.state}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>以下、住所</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model.trim="form.street" placeholder="以下、住所" maxlength="32">
                <div v-if="errors.street" class="error_text">{{errors.street}}</div>
              </li>
              <li class="input_text2">
                <div>
                  <span>氏名</span>
                  <span class="important small_text">必須</span>
                </div>
                <div class="input_field">
                  <input type="text" v-model.trim="form.userLastName" maxlength="32" placeholder="家具"/>
                  <span class="space"></span>
                  <input type="text" v-model.trim="form.userFirstName" maxlength="32" placeholder="太郎"/>
                </div>
                <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
              </li>
              <li class="input_text2">
                <div>
                  <span>氏名（カナ）</span>
                  <span class="important small_text">必須</span>
                </div>
                <div class="input_field">
                  <input type="text" v-model.trim="form.userLastNameKana" maxlength="32" placeholder="カグ"/>
                  <span class="space"></span>
                  <input type="text" v-model.trim="form.userFirstNameKana" maxlength="32" placeholder="タロウ"/>
                </div>
                <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>電話番号</span>
                  <span class="small_p">（半角数値、ハイフン不要）</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model.trim="form.tel" @keypress="validateNumber" @input="form.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="0123456789" maxlength="11"/>
                <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>メールアドレス</span>
                  <span class="small_p">（半角数値、ハイフン不要）</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model.trim="form.email" placeholder="****@domans.co.jp" maxlength="128"/>
                <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>部署名</span>
                </div>
                <input type="text" v-model.trim="form.department" placeholder="部署名" maxlength="11"/>
                <div v-if="errors.department" class="error_text">{{errors.department}}</div>
              </li>
            </ul>
          </div>
          <div class="control_btn_area">
            <div class="detail_btn2" @click="confirm()">登録する</div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL} from '../../constants/App'
import * as Check from '../../utils/Check'
import * as FormUtil from '../../utils/FormUtil'
import LoadingModal from '../../components/common/LoadingModal'
import Header from '../components/common/DcHeader'
import LeftMenu from '../components/top/DcLeftMenu'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'

export default {
  name: 'ClientInput',
  components: {
    'dd-header': Header,
    'dd-menu': LeftMenu,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      form: {},
      errors: {},
      pageKey: 'dcClientInput',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'dcClientInput', key: 'dcClientInput', title: '顧客情報登録', route: 'DcClientInput'}
      ],
      confirmFlag: false
    }
  },
  methods: {
    confirm: function () {
      // 入力エラーのクリア
      this.$refs.loadingModalRef.showModal(true)
      this.errors = {}
      this.confirmFlag = true

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.confirmFlag = false
        this.$refs.loadingModalRef.showModal(false)
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.confirmFlag = false
        this.$refs.loadingModalRef.showModal(false)
        return false
      }
      axios.post(DC_URL.TOP + '/payment-register', this.form)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            this.$router.push({
              name: 'DcClientComplete'
            })
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
        }).finally(() => {
          this.confirmFlag = false
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    validateRequire: function () {
      // 必須チェック
      if (!this.form.corpName) this.errors['corpName'] = '会社名は必須項目です。'
      if (!this.form.postcd) this.errors['postcd'] = '郵便番号は必須項目です。'
      if (!this.form.state || !this.form.city) this.errors['state'] = '住所は必須項目です。'
      if (!this.form.street) this.errors['street'] = '以下、住所は必須項目です。'
      if (!this.form.userLastName || !this.form.userFirstName) this.errors['userName'] = '氏名は必須項目です。'
      if (!this.form.userLastNameKana || !this.form.userFirstNameKana) this.errors['userNameKana'] = '氏名（カナ）は必須項目です。'
      if (!this.form.tel) this.errors['tel'] = '電話番号は必須項目です。'
      if (!this.form.email) this.errors['email'] = 'メールアドレスは必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isPostCd(this.form.postcd)) this.errors['postcd'] = '郵便番号は半角数値で入力してください。'
      if (!Check.isTel(this.form.tel)) this.errors['tel'] = '電話番号は半角数値かつ、10～11文字で入力してください。'
      if (!Check.isKana(this.form.userLastNameKana) || !Check.isKana(this.form.userFirstNameKana)) this.errors['userNameKana'] = '氏名（カナ）はカタカナで入力してください。'
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    fetchData: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
      }
      axios.post(DC_URL.USER + '/edit', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$set(this.form, 'corpName', response.data.data.corpName)
            this.$set(this.form, 'tel', response.data.data.tel)
            this.$set(this.form, 'postcd', response.data.data.postcd)
            this.$set(this.form, 'state', response.data.data.state)
            this.$set(this.form, 'city', response.data.data.city)
            this.$set(this.form, 'street', response.data.data.street)

            this.$set(this.form, 'email', response.data.data.userList[0].email)
            this.$set(this.form, 'department', response.data.data.userList[0].userDepartment)
            this.$set(this.form, 'userLastName', response.data.data.userList[0].userLastName)
            this.$set(this.form, 'userFirstName', response.data.data.userList[0].userFirstName)
            this.$set(this.form, 'userLastNameKana', response.data.data.userList[0].userLastNameKana)
            this.$set(this.form, 'userFirstNameKana', response.data.data.userList[0].userFirstNameKana)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.fetchData()
  },
  created () {
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcClientInput.vue